var map = {
	"./Agropalma.png": 2752,
	"./BASF.svg": 8860,
	"./Carozzi.png": 9052,
	"./ChrHansen.svg": 1242,
	"./DSM.png": 1686,
	"./Dupont.png": 988,
	"./F&FIngredients.png": 7423,
	"./FrieslandCampina.png": 8881,
	"./IFF.png": 4071,
	"./PureCircle.png": 5784,
	"./Rousselot.png": 2065,
	"./pronex.png": 7166
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1926;